import { api } from '../config/api';

export const userCategoryService = {
  // Obtener todas las categorías
  getAll: async () => {
    return await api.get('/user-categories/');
  },

  // Obtener una categoría por ID
  getById: async (id) => {
    return await api.get(`/user-categories/${id}/`);
  },

  // Crear una categoría
  create: async (categoryData) => {
    return await api.post('/user-categories/', categoryData);
  },

  // Actualizar una categoría
  update: async (id, categoryData) => {
    return await api.put(`/user-categories/${id}/`, categoryData);
  },

  // Eliminar una categoría
  delete: async (id) => {
    return await api.delete(`/user-categories/${id}/`);
  }
};

